import { api } from '@shared/api/api';

export type RegistrationResult = {
  registrationId: number;
  companyId: number;
  name: string;
  score: number;
};

export type UserResult = {
  userId: number;
  firstName: string;
  lastName: string;
  score: number;
  companyIds: number[];
};

export type SearchCompanyOrUserResponse = {
  users: Array<UserResult>;
  registrations: Array<RegistrationResult>;
};
export function searchRegistrationOrUser(eventId: number, query: string): Promise<SearchCompanyOrUserResponse> {
  return api.post(`events/${eventId}/search`, { query });
}
